module.exports = __webpack_public_path__ + "img/infographic-empty.beab89e1.png";